module.exports = __webpack_public_path__ + "static/mypic-c4bf24187adc56c2a9bbe8f5bd578a96.jpg";